<template>
  <div class="validasi-page">
    <PageHeader
      icon="mdi-check-all"
      title="Validasi"
      subtitle="Semakan validasi tambahan mengikut HID"
    />

    <v-card outlined class="mb-4">
      <v-card-title class="py-3 d-flex align-center flex-wrap kad__tajuk">
        <v-icon small class="mr-2">mdi-magnify</v-icon>
        <span class="subtitle-1 font-weight-medium">Carian HID</span>
      </v-card-title>
      
      <v-card-text class="filter-bar py-4">
        <v-form ref="formcariexport" @submit.prevent="getData">
          <v-row align="end" dense>
            <v-col cols="12" sm="4">
              <div class="fld__label">HID</div>
              <v-text-field
                outlined
                dense
                hide-details
                maxlength="16"
                placeholder="Masukkan HID"
                v-model="HID"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="auto">
              <v-btn height="40" class="btn-teal text-none mr-2" @click="getData()" :disabled="!HID">
                <v-icon left small>mdi-check-circle-outline</v-icon> Semakan Validasi
              </v-btn>
              <v-btn outlined height="40" class="text-none reset-btn" @click="resetFilter">
                <v-icon small left>mdi-refresh</v-icon>
                Tetapkan Semula
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-card outlined class="mb-4 mt-4" v-if="listRalatValidasiTambahan !== ''">
      <v-card-title class="py-3 d-flex align-center flex-wrap kad__tajuk" :class="{'kad__tajuk--ralat': hasError}">
        <v-icon small class="mr-2" :color="hasError ? '#d9534f' : '#037769'">
          {{ hasError ? 'mdi-alert-circle' : 'mdi-check-circle' }}
        </v-icon>
        <span class="subtitle-1 font-weight-medium" :class="hasError ? 'red--text text--darken-1' : 'primary--text'" :style="!hasError ? 'color: #037769 !important;' : ''">
          Keputusan Validasi {{ hasError ? '(Ralat)' : '(Lulus)' }}
        </span>
      </v-card-title>
      
      <v-card-text class="pa-0" v-if="hasError">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr class="grey lighten-4">
                <th class="text-left font-weight-bold" style="width: 80px;">No.</th>
                <th class="text-left font-weight-bold">Keterangan</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in listRalatValidasiTambahan" :key="index">
                <td>{{ index + 1 }}</td>
                <td class="red--text text--darken-2">{{ item }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      
      <v-card-text class="pt-5 pb-5 text-center" v-else>
        <div class="d-flex flex-column align-center justify-center">
          <v-icon color="#037769" size="64">mdi-check-circle-outline</v-icon> 
          <div class="mt-4 text-h6" style="color: #037769;">Tiada ralat ditemui</div>
          <div class="subtitle-1 grey--text text--darken-1">Semakan validasi tambahan untuk HID {{ dataHID && dataHID.hid ? dataHID.hid : HID }} telah berjaya.</div>
        </div>
      </v-card-text>
    </v-card>

    <Overlay v-show="showOverlay"/>
  </div>
</template>
<script>
import i18n from "@/i18n";
import axios from "../../plugins/axios";

import validasiTambahan from "./validasiTambahan.js"
import Overlay from '../../components/Overlay'
const validation = new validasiTambahan();

export default {
  Name: "validasi",
  props: ['noHID'], 
  components: {
    Overlay
  },
  computed: {
    hasError() {
      if (!this.listRalatValidasiTambahan) return false;
      if (Array.isArray(this.listRalatValidasiTambahan)) {
        return this.listRalatValidasiTambahan.length > 0;
      }
      return Object.keys(this.listRalatValidasiTambahan).length > 0;
    }
  },
  setup() {},
  data: () => ({
   HID:'',
   dataHID:'',
   listRalatValidasiTambahan:'',
   showOverlay: false,
  }),
  mounted(){
    if (this.noHID !== undefined) {
      this.HID = this.noHID;
      this.getData();
    }
  },
  methods: {
    resetFilter() {
      this.HID = '';
      this.listRalatValidasiTambahan = '';
      this.dataHID = '';
    },
    async getData(){
       try{   
          this.showOverlay = true;
          const res = await axios.post(`${process.env.VUE_APP_API_URL}/validation/getData`, {'HID': this.HID})
          
          this.dataHID = res.data.data;
          this.startValidation(this.dataHID);
        } catch (error) {
          this.showOverlay = false;
          console.log(error);
        }
    },
    async startValidation(dataHID){
      try{
        this.listRalatValidasiTambahan = await validation.semakanValidasiTambahan(dataHID);
        this.showOverlay = false;
      }catch(e){
        this.showOverlay = false;
        console.log("ralat :"+e)
        alert(e)
      }
    }
  },
};
</script>

<style scoped>
/* ─── Filter bar ─── */
.filter-bar {
  background: #f7fcfb;
  border-top: 1px solid #dbeeeb;
  border-bottom: 1px solid #dbeeeb;
}

.validasi-page .fld__label {
  font-size: var(--fs-3xs, 12px);
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #7aa8a2;
  line-height: 1.4;
  margin-bottom: 5px;
  white-space: nowrap;
}

.validasi-page .filter-bar .v-input fieldset {
  border-color: #cfeae7;
}
.validasi-page .filter-bar .v-input--is-focused fieldset {
  border-color: #037769 !important;
  border-width: 1px;
}

.kad__tajuk {
  border-bottom: 1px solid #dbeeeb;
}
.kad__tajuk .v-icon {
  color: #037769;
}
.kad__tajuk--ralat { border-bottom-color: #f3c9c7; }
.kad__tajuk--ralat .v-icon { color: #d9534f; }

.btn-teal.v-btn {
  background: #037769 !important;
  color: #ffffff !important;
  letter-spacing: normal;
}
.btn-teal.v-btn:hover { background: #026254 !important; }
.btn-teal.v-btn .v-icon { color: #ffffff !important; }
.btn-teal.v-btn--disabled {
  background: #cfd8dc !important;
  color: rgba(0, 0, 0, .38) !important;
}
.btn-teal.v-btn--disabled .v-icon { color: rgba(0, 0, 0, .38) !important; }
</style>